module.exports = __webpack_public_path__ + "static/media/argon-react.5d250acd.png";